import { render, staticRenderFns } from "./FileEntryActions.vue?vue&type=template&id=97638e40&scoped=true"
import script from "./FileEntryActions.vue?vue&type=script&lang=ts"
export * from "./FileEntryActions.vue?vue&type=script&lang=ts"
import style0 from "./FileEntryActions.vue?vue&type=style&index=0&id=97638e40&prod&lang=scss"
import style1 from "./FileEntryActions.vue?vue&type=style&index=1&id=97638e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97638e40",
  null
  
)

export default component.exports